<template>
  <div class="full-page-width relative locations">
    <ConfirmationBar
      :showSavebar="showSavebar"
      @confirm="submitForm"
      @cancel="cancel"
    />
    <div class="row">
      <div class="col-xs-4 text-box">
        <InfoTextBox
          :text="$t('system-reference-info-text')"
          :title="$t('Required')" />
      </div>
      <div class="col-xs-8">
        <div class="card p-40">
          <div class="toggle-card m-b-40">
            <div>
              <span class="title">{{ $t('Shipper reference') }}</span>
              <span class="additional-info">{{ $t('Shipper reference should be required') }}</span>
            </div>
            <Toggle id="is_shipper_reference_required"
              v-model="form.is_shipper_reference_required" />
          </div>
          <div class="toggle-card  m-b-40">
            <div>
              <span class="title">{{ $t('Receiver reference') }}</span>
              <span class="additional-info">{{ $t('Receiver reference should be required') }}</span>
            </div>
            <Toggle id="is_receiver_reference_required"
              v-model="form.is_receiver_reference_required" />
          </div>
          <div class="toggle-card m-b-40">
            <div>
              <span class="title">{{ $t('required_email_title') }}</span>
              <span class="additional-info">{{ $t('required_email_additional_info') }}</span>
            </div>
            <Toggle id="is_email_required"
                    v-model="form.is_email_required" />
          </div>
          <div class="toggle-card">
            <div>
              <span class="title">{{ $t('required_phone_title') }}</span>
              <span class="additional-info">{{ $t('required_phone_additional_info') }}</span>
            </div>
            <Toggle id="is_phone_required"
                    v-model="form.is_phone_required" />
          </div>
        </div>
      </div>
    </div>
    <div class="separator"></div>
    <div class="row">
      <div class="col-xs-4 text-box">
        <InfoTextBox
          :text="$t('system-printing-info-text')"
          :title="$t('Printing')" />
      </div>
      <div class="col-xs-8">
        <div class="card p-40">
          <div class="toggle-card m-b-40">
            <div>
              <span class="title">{{ $t('Draft bulk print colli details') }}</span>
              <span class="additional-info">{{ $t('Shows popup with colli details') }}</span>
            </div>
            <Toggle id="showBox"
              v-model="form.is_show_box" />
          </div>
          <div class="toggle-card">
            <div>
              <span class="title">{{ $t('Printing error details on a blank label') }}</span>
              <span class="additional-info">{{ $t('When error by booking a shipment') }}</span>
            </div>
            <Toggle id="printLabel"
              v-model="form.is_print_error_label" />
          </div>
        </div>
      </div>
    </div>
    <div class="separator"></div>
    <div class="row">
      <div class="col-xs-4 text-box">
        <InfoTextBox
          :text="$t('system-notification-info-text')"
          :title="$t('Notifications')" />
      </div>
      <div class="col-xs-8">
        <div class="card p-40">
          <InputSelect
            :label="$t('When should shipment notification be send?')"
            class="m-b-20"
            v-model="form.shipment_notification"
            :options="selectOptions(get_systems.entity['type'])" />
          <InputSelect
            :label="$t('Other notification')"
            :multiSelect=true
            :preselected="form.other_shipment_notification_events"
            v-model="form.other_shipment_notification_events"
            :options="selectOptionsObj(get_systems.entity['other_notification_event_type'])" />
        </div>
      </div>
    </div>
    <div class="separator"></div>
    <div class="row">
      <div class="col-xs-4 text-box">
        <InfoTextBox
          :text="$t('system-eod-info-text')"
          :title="$t('EOD options')" />
      </div>
      <div class="col-xs-8">
        <div class="card p-40">
          <InputSelect
            :label="$t('EOD options')"
            v-model="form.eod_action_type"
            :options="selectOptions(get_systems.entity['eod_action_types'])" />
        </div>
      </div>
    </div>
    <div class="separator"></div>
    <div class="row m-b-40">
      <div class="col-xs-4 text-box">
        <InfoTextBox
          :text="$t('system-automated-info-text')"
          :title="$t('Automated EOD print')" />
      </div>
      <div class="col-xs-8">
        <div class="card p-40">
          <InputSelect
            :label="$t('Automated EOD print')"
            v-model="form.eod_print_type"
            :options="selectOptions(get_systems.entity['eod_print_types'])" />
        </div>
      </div>
    </div>
    <div class="separator"></div>
    <div class="row">
      <div class="col-xs-4 text-box">
        <InfoTextBox
          :text="$t('booking-page-options-text')"
          :title="$t('booking_page_options')" />
      </div>
      <div class="col-xs-8">
        <div class="card p-40">
          <div class="toggle-card m-b-40">
            <div>
              <span class="title">{{ $t('should_save_booking_address') }}</span>
              <span class="additional-info">{{ $t('should_save_booking_address_subtext') }}</span>
            </div>
            <Toggle id="should_save_booking_address"
                    v-model="form.should_save_booking_address" />
          </div>
          <div class="toggle-card m-b-40">
            <div>
              <span class="title">{{ $t('show_content_lines') }}</span>
              <span class="additional-info">{{ $t('show_content_lines_subtext') }}</span>
            </div>
            <Toggle id="show_booking_colli_content"
                    v-model="form.show_booking_colli_content" />
          </div>
<!--          <div class="toggle-card m-b-40">-->
<!--            <div>-->
<!--              <span class="title">{{ $t('show_colli_amount') }}</span>-->
<!--              <span class="additional-info">{{ $t('show_colli_amount_subtext') }}</span>-->
<!--            </div>-->
<!--            <Toggle id="show_booking_colli_amount"-->
<!--                    v-model="form.show_booking_colli_amount" />-->
<!--          </div>-->
          <div class="toggle-card m-b-40">
            <div>
              <span class="title">{{ $t('show_info_box') }}</span>
              <span class="additional-info">{{ $t('show_info_box_subtext') }}</span>
            </div>
            <Toggle id="show_booking_info_box"
                    v-model="form.show_booking_info_box" />
          </div>
          <div class="toggle-card m-b-40">
            <div>
              <span class="title">{{ $t('always_show_document_upload') }}</span>
              <span class="additional-info">{{ $t('always_show_document_upload_subtext') }}</span>
            </div>
            <Toggle id="always_show_document_upload"
                    v-model="form.always_show_document_upload" />
          </div>
          <div class="toggle-card m-b-40">
            <div>
              <span class="title">{{ $t('copy_sender_phone_email_to_receiver') }}</span>
              <span class="additional-info">{{ $t('copy_sender_phone_email_to_receiver_additional_info') }}</span>
            </div>
            <Toggle id="should_copy_from_sender_to_receiver"
                    v-model="form.should_copy_from_sender_to_receiver" />
          </div>
          <div class="m-b-20">
            <InputSelect
              :label="$t('sender_handling_type')"
              v-model="form.sender_handling_type"
              :options="selectOptions(get_systems.entity['sender_handling_types'])" />
          </div>
        </div>
      </div>
    </div>
    <div class="separator"></div>
    <div class="row">
      <div class="col-xs-4 text-box">
        <InfoTextBox
          :text="$t('customs_information_subtext')"
          :title="$t('customs_information_title')" />
      </div>
      <div class="col-xs-8">
        <div class="card p-40">
          <div class="toggle-card m-b-40">
            <div>
              <span class="title">{{ $t('convert_customs_value_to_domestic') }}</span>
              <span class="additional-info">{{ $t('convert_customs_value_to_domestic_additional_info') }}</span>
            </div>
            <Toggle id="convert_customs_value_to_domestic"
                    v-model="form.convert_customs_value_to_domestic" />
          </div>
          <div class="toggle-card m-b-40">
            <div>
              <span class="title">{{ $t('show_shipping_cost_title') }}</span>
              <span class="additional-info">{{ $t('show_shipping_cost_additional_info') }}</span>
            </div>
            <Toggle id="show_shipping_cost"
                    v-model="form.show_shipping_cost" />
          </div>
          <div class="toggle-card m-b-40">
            <div>
              <span class="title">{{ $t('group_content_title') }}</span>
              <span class="additional-info">{{ $t('group_content_additional_info') }}</span>
            </div>
            <Toggle id="should_group_content"
                    v-model="form.should_group_content" />
          </div>
        </div>
      </div>
    </div>
    <div class="separator"></div>
    <div class="row">
      <div class="col-xs-4 text-box">
        <InfoTextBox
          :text="$t('should_print_dg_document')"
          :title="$t('should_print_dg_document_title')" />
      </div>
      <div class="col-xs-8">
        <div class="card p-40">
          <div class="toggle-card m-b-40">
            <div>
              <span class="title">{{ $t('should_print_dg_document_toggle') }}</span>
              <span class="additional-info">{{ $t('should_print_dg_document_subtext') }}</span>
            </div>
            <Toggle id="should_print_dg_document"
                    v-model="form.should_print_dg_document" />
          </div>
        </div>
      </div>
    </div>
    <div class="separator"></div>
    <div class="row">
      <div class="col-xs-4 text-box">
        <InfoTextBox
          :text="$t('gdpr_side_text')"
          :title="$t('gdpr_side_title')" />
      </div>
      <div class="col-xs-8">
        <div class="card p-40">
          <div class="toggle-card m-b-40">
            <div>
              <span class="title">{{ $t('gdpr_anonymization_active') }}</span>
              <span class="additional-info">{{ $t('gdpr_anonymization_active_info') }}</span>
            </div>
            <Toggle id="is_gdpr_active"
                    v-model="form.is_gdpr_active" />
          </div>
          <div class="row" v-if="form.is_gdpr_active">
            <InputText
              class="col-xs-12"
              :label="$t('gdpr_title')"
              :rules="{required: form.is_gdpr_active}"
              v-model="form.gdpr_days"/>
          </div>
        </div>
      </div>
    </div>
    <div class="separator"></div>
    <div class="row">
      <div class="col-xs-4 text-box">
        <InfoTextBox
          :title="$t('Custom Tags')"
          :text="$t('system-tags-info-text')"
          :btnText="$t('Add custom tag')"
          @action="openNewPopup" />
      </div>
      <div class="col-xs-8">
        <ul class="list-table">
          <li
            @click="openEditPopup(index)"
            class="list-table-item"
            v-for="(item, index) in form.custom_tag_json" :key="`item-${index}`">
            <div class="table-cell small">
              <Icon
                :circle=true
                name="tag"
                size="20" />
            </div>
            <div class="table-cell">
              <p>
              <span class="main-info">
                {{ `${item.custom_tag_name}` }}
              </span>
                <span class="additional-info">
                  {{ `${item.custom_tag_value}` }}
                </span>
              </p>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="separator"></div>
    <Popup
      v-if="openPopup"
      :popupSmall=true
      :isPopupSubmitDisabled="isPopupSubmitDisabled"
      :showConfirmButton="!deleteTag"
      :showDeleteButton="deleteTag"
      @cancel="cancelForm"
      @deleteAction="deleteTagAction"
      @confirm="submitForm">
      <template v-slot:header>
        <h2 v-if="!isEdit">{{ $t('Add custom tag') }}</h2>
        <h2 v-if="isEdit">{{ $t('Edit custom tag') }}</h2>
      </template>
      <div>
        <div class="row">
          <div class="col-xs-12">
            <div class="flex-center toggle-title">
              <div>
                <p>{{ $t('error_required_field') }}</p>
                <span>{{ $t('Custom tag is required') }}</span>
              </div>
              <div>
                <Toggle id="requiredCustomTag" v-model="form.custom_tag_json[editIndex].custom_tag_is_required" />
              </div>
            </div>
          </div>
        </div>
        <div class="separator medium"></div>
        <div class="row">
          <InputText
            class="col-xs-12 m-b-20"
            :label="$t('name')"
            :rules="{required: true}"
            v-model="form.custom_tag_json[editIndex].custom_tag_name"/>
        </div>
        <div class="row">
          <InputText
            class="col-xs-12"
            :label="$t('value')"
            v-model="form.custom_tag_json[editIndex].custom_tag_value"/>
        </div>
      </div>
      <div class="separator medium" v-if="isEdit"></div>
        <div class="row">
          <div class="col-xs-12" v-if="isEdit">
            <div class="flex-center toggle-title">
              <div>
                <p>{{ $t('delete') }}</p>
                <span>{{ $t('Tag will be deleted') }}</span>
              </div>
              <div>
                <Toggle color="red" id="deleteTag" v-model="deleteTag" />
              </div>
            </div>
          </div>
        </div>
    </Popup>
  </div>
</template>
<script>
/* eslint-disable */
import { mapGetters } from 'vuex';
import Btn from '@/components/elements/buttons';
import InputText from '@/components/elements/inputs/text.vue';
import Popup from '@/components/global/popup';
import InputSelect from '@/components/elements/inputs/select.vue';
import Toggle from '@/components/elements/inputs/toggle.vue';

import InfoTextBox from '@/components/global/infoTextBox';
import ConfirmationBar from '@/components/global/confirmationBar';
import formValidator from '@/mixins/formValidator';

export default {
  name: 'System',
  mixins: [formValidator],
  components: {
    Btn,
    Popup,
    InputText,
    InputSelect,
    Toggle,
    InfoTextBox,
    ConfirmationBar,
  },
  data() {
    return {
      editIndex: '',
      openPopup: false,
      isEdit: false,
      systemId: '',
      deleteTag: false,
      form: {
        is_show_box: false,
        is_print_error_label: false,
        shipment_notification: '',
        eod_action_type: '',
        eod_print_type: '',
        is_gdpr_active: false,
        gdpr_days: '',
        custom_tag_json: [],
        is_shipper_reference_required: false,
        is_receiver_reference_required: false,
        other_shipment_notification_events: [],
        show_booking_colli_content: false,
        show_booking_colli_amount: true,
        show_booking_info_box: false,
        always_show_document_upload: false,
        is_email_required: false,
        is_phone_required: false,
        should_copy_from_sender_to_receiver: false,
        should_print_dg_document: false,
        convert_customs_value_to_domestic: false,
        should_save_booking_address: true,
        show_shipping_cost: false,
        sender_handling_type: '',
        should_group_content: false
      },
      beforeEditState: null,
      // Confirmation savebar
      showSavebar: false,
      savebarEnabled: false,
    };
  },
  computed: {
    ...mapGetters([
      'get_systems',
      'get_system_by_id',
    ]),
    isPopupSubmitDisabled() {
      return this.validateInput([
        {
          formFeild:'name',
          value: this.form.custom_tag_json[this.editIndex].custom_tag_name,
          validators:{required: true}
        },
      ]);
    },
  },
  created() {
    this.$store.dispatch('GET_SYSTEMS').then((res) => {
      if (res.items.length) {
        this.form.is_show_box = res.items[0].is_show_box;
        this.form.is_print_error_label = res.items[0].is_print_error_label;
        this.form.shipment_notification = res.items[0].shipment_notification;
        this.form.eod_action_type = res.items[0].eod_action_type;
        this.form.eod_print_type = res.items[0].eod_print_type;
        this.form.custom_tag_json = res.items[0].custom_tag_json;
        this.form.is_shipper_reference_required = res.items[0].is_shipper_reference_required;
        this.form.is_receiver_reference_required = res.items[0].is_receiver_reference_required;
        this.form.other_shipment_notification_events = res.items[0].other_shipment_notification_events_array === null ? [] : res.items[0].other_shipment_notification_events_array;
        this.form.show_booking_colli_content = res.items[0].show_booking_colli_content;
        this.form.show_booking_colli_amount = res.items[0].show_booking_colli_amount;
        this.form.show_booking_info_box = res.items[0].show_booking_info_box;
        this.form.always_show_document_upload = res.items[0].always_show_document_upload;
        this.form.is_email_required = res.items[0].is_email_required;
        this.form.is_phone_required = res.items[0].is_phone_required;
        this.form.should_copy_from_sender_to_receiver = res.items[0].should_copy_from_sender_to_receiver;
        this.form.should_print_dg_document = res.items[0].should_print_dg_document;
        this.form.convert_customs_value_to_domestic = res.items[0].convert_customs_value_to_domestic;
        this.form.should_save_booking_address = res.items[0].should_save_booking_address;
        this.form.show_shipping_cost = res.items[0].show_shipping_cost;
        this.form.is_gdpr_active = res.items[0].is_gdpr_active;
        this.form.gdpr_days = res.items[0].gdpr_days;
        this.form.sender_handling_type = res.items[0].sender_handling_type;
        this.form.should_group_content = res.items[0].should_group_content;
      }

      this.$nextTick(() => {
        this.savebarEnabled = true;
      })
    });
  },
  methods: {
    selectOptions(obj) {
      const options = [];
      for (const property in obj) {
        options.push({ text: obj[property], value: parseInt(property) });
      }
      return options;
    },
    selectOptionsObj(obj) {
      const options = [];
      for (const property in obj) {
        options.push({ text: obj[property], value: property });
      }
      return options;
    },
    togglePopup() {
      this.openPopup = !this.openPopup;
    },
    cancel() {
      this.showSavebar = false;
    },
    submitForm() {
      this.$store.dispatch('SET_SYSTEM', {
        form: this.form,
      }).then(() => {
        this.$store.dispatch('GET_SYSTEMS');
        this.openPopup = false;
        this.showSavebar = false;
        this.deleteTag = false;
      });
    },
    cancelForm() {
      if(!this.isEdit) {
        [this.form.custom_tag_json.pop()]
      } else {
        this.form.custom_tag_json[this.editIndex] = {...this.beforeEditState};
        this.beforeEditState = null;
      }
      this.togglePopup();
    },
    openNewPopup() {
      this.isEdit = false;
      this.form.custom_tag_json.push({
        custom_tag_is_required: false,
        custom_tag_name: '',
        custom_tag_value: '',
      });
      this.editIndex = this.form.custom_tag_json.length - 1;
      this.togglePopup();
    },
    openEditPopup(index) {
      this.isEdit = true;
      this.editIndex = index;
      this.beforeEditState = {...this.form.custom_tag_json[index]};
      this.togglePopup();
    },
    deleteTagAction() {
      this.form.custom_tag_json.splice(this.editIndex, 1);
      this.submitForm();
    },
  },
  watch: {
    // SAVEBAR
    'form.is_shipper_reference_required': {
      handler(){
        if(this.savebarEnabled){
          this.showSavebar = true;
        }
      },
      deep: true
    },
    'form.is_receiver_reference_required': {
      handler(){
        if(this.savebarEnabled){
          this.showSavebar = true;
        }
      },
      deep: true
    },
    'form.is_show_box': {
      handler(){
        if(this.savebarEnabled){
          this.showSavebar = true;
        }
      },
      deep: true
    },
    'form.is_print_error_label': {
      handler(){
        if(this.savebarEnabled){
          this.showSavebar = true;
        }
      },
      deep: true
    },
    'form.shipment_notification': {
      handler(){
        if(this.savebarEnabled){
          this.showSavebar = true;
        }
      },
      deep: true
    },
    'form.other_shipment_notification_events': {
      handler(){
        if(this.savebarEnabled){
          this.showSavebar = true;
        }
      },
      deep: true
    },
    'form.eod_action_type': {
      handler(){
        if(this.savebarEnabled){
          this.showSavebar = true;
        }
      },
      deep: true
    },
    'form.eod_print_type': {
      handler(){
        if(this.savebarEnabled){
          this.showSavebar = true;
        }
      },
      deep: true
    },
    'form.show_booking_colli_content': {
      handler(){
        if(this.savebarEnabled){
          this.showSavebar = true;
        }
      },
      deep: true
    },
    'form.show_booking_colli_amount': {
      handler(){
        if(this.savebarEnabled){
          this.showSavebar = true;
        }
      },
      deep: true
    },
    'form.show_booking_info_box': {
      handler(){
        if(this.savebarEnabled){
          this.showSavebar = true;
        }
      },
      deep: true
    },
    'form.always_show_document_upload': {
      handler(){
        if(this.savebarEnabled){
          this.showSavebar = true;
        }
      },
      deep: true
    },
    'form.is_phone_required': {
      handler(){
        if(this.savebarEnabled){
          this.showSavebar = true;
        }
      },
      deep: true
    },
    'form.is_email_required': {
      handler(){
        if(this.savebarEnabled){
          this.showSavebar = true;
        }
      },
      deep: true
    },
    'form.should_copy_from_sender_to_receiver': {
      handler(){
        if(this.savebarEnabled){
          this.showSavebar = true;
        }
      },
      deep: true
    },
    'form.should_print_dg_document': {
      handler(){
        if(this.savebarEnabled){
          this.showSavebar = true;
        }
      },
      deep: true
    },
    'form.convert_customs_value_to_domestic': {
      handler(){
        if(this.savebarEnabled){
          this.showSavebar = true;
        }
      },
      deep: true
    },
    'form.should_save_booking_address': {
      handler(){
        if(this.savebarEnabled){
          this.showSavebar = true;
        }
      },
      deep: true
    },
    'form.show_shipping_cost': {
      handler(){
        if(this.savebarEnabled){
          this.showSavebar = true;
        }
      },
      deep: true
    },
    'form.gdpr_days': {
      handler(){
        if(this.savebarEnabled){
          this.showSavebar = true;
        }
      },
      deep: true
    },
    'form.sender_handling_type': {
      handler(){
        if(this.savebarEnabled){
          this.showSavebar = true;
        }
      },
      deep: true
    },
    'form.should_group_content': {
      handler(){
        if(this.savebarEnabled){
          this.showSavebar = true;
        }
      },
      deep: true
    },
    'form.is_gdpr_active': {
      handler() {
        if (this.savebarEnabled) {
          this.showSavebar = true;
        }
      },
      deep: true
    },
  }
};
</script>
